import React, { useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSWR from 'swr';

import axios from '../../admin-axios';
import { ReactComponent as CashIcon } from '../../assets/Images/cash_icon.svg';
import { ReactComponent as CylinderIcon } from '../../assets/Images/cylinder_icon.svg';
import { convertTons, detectError, nFormatter } from '../../utils';
import DSRChart from '../DSRChart';
import classes from './index.module.scss';

const fetcher = (url) => axios.get(url).then((res) => res.data);

const DSRHome = ({ match }) => {
  const {
    user: { stationId }
  } = useSelector((state) => state.auth);
  const {
    data,
    error,
    isLoading: loading
  } = useSWR(`/transaction/daily/sales/${stationId}`, fetcher);

  if (error) {
    toast.error(detectError(error));
  }

  // const pump_data = [
  //   {
  //     gas_pump_id: 'Pump 1',
  //     total_gas_filled: 250
  //   },
  //   {
  //     gas_pump_id: 'Pump 2',
  //     total_gas_filled: 350
  //   },
  //   {
  //     gas_pump_id: 'Pump 3',
  //     total_gas_filled: 150
  //   },
  //   {
  //     gas_pump_id: 'Pump 4',
  //     total_gas_filled: 450
  //   }
  // ];

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className={`${classes.daily_records}`}>
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 col-lg-6">
            <div className="d-flex justify-content-between">
              <h3 className="py-2">Sales Graph</h3>
              <div>
                <input
                  type="date"
                  name="filter_date"
                  placeholder="Choose Filter Date"
                  className={`form-control ${classes.daily_records_filter_date}`}
                />
              </div>
              <button className={`btn ${classes.daily_records_filter_button}`} type="button">
                Apply Filter
              </button>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="py-3">
              <h4>Last updated as at {new Date().toLocaleTimeString()}</h4>
            </div>
          </div>
        </div>

        <div className="row g-5 mb-5">
          <div className="col-xl-6">
            <div className="d-flex justify-content-center align-items-center dashboard_graph ps-2">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center w-100 h-100">
                  <Spinner className="spinner" animation="border" variant="dark" />
                </div>
              ) : (
                // <MyResponsiveBar data={salesGraph} currency={currency} />
                <div className="w-100 h-100 bg-light d-flex justify-content-center align-items-center">
                  {/* {data && <DSRChart data={data.pump_data} currency={data.currency} />} */}
                  {data && <DSRChart data={data.pump_data} currency={data.currency} />}
                </div>
              )}
            </div>
          </div>

          <div className="col-xl-6">
            <div className="row g-3">
              <div className="col-sm-6">
                <div className={`${classes.daily_records_box} w-100`}>
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  ) : (
                    <>
                      <CylinderIcon />
                      <p className={`${classes.daily_records_box_main_text}`}>
                        {data && convertTons(data.total_gas_sold)}
                      </p>
                      <p className={`${classes.daily_records_box_sub_text}`}>
                        Total gas quantity sold
                      </p>
                    </>
                  )}
                </div>
              </div>
              <div className="col-sm-6">
                <div className={`${classes.daily_records_box} w-100`}>
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100">
                      <Spinner className="spinner" animation="border" variant="light" />
                    </div>
                  ) : (
                    <>
                      <CashIcon />
                      <p className={`${classes.daily_records_box_main_text}`}>
                        {data && data.currency} {data && nFormatter(data.total_sales_made, 2)}
                      </p>
                      <p className={`${classes.daily_records_box_sub_text}`}>Total sales made</p>
                    </>
                  )}
                </div>
              </div>
              <div className="col-sm-6">
                <div className={`${classes.daily_records_box} w-100`}>
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  ) : (
                    <>
                      <CashIcon />
                      <p className={`${classes.daily_records_box_main_text}`}>
                        {data && data.currency} {data && nFormatter(data.total_amount_received, 2)}
                      </p>
                      <p className={`${classes.daily_records_box_sub_text}`}>
                        Total amount received
                      </p>
                    </>
                  )}
                </div>
              </div>
              <div className="col-sm-6">
                <div className={`${classes.daily_records_box} w-100`}>
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center w-100 h-100">
                      <Spinner className="spinner" animation="border" variant="light" />
                    </div>
                  ) : (
                    <>
                      <CashIcon />
                      <p className={`${classes.daily_records_box_main_text}`}>
                        {data && data.currency} {data && nFormatter(Math.abs(data.total_debt), 2)}
                      </p>
                      <p className={`${classes.daily_records_box_sub_text}`}>Total debt</p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-5 mb-5">
          <div className="col-12 col-xl-6">
            <div className={`${classes.daily_records_boxes} p-3 bg-light`}>
              <h4>Retailers</h4>
              <hr />
              <div className="row">
                <div className="col-6">
                  <p className="fw-bold fs-4">{data && convertTons(data.retailer_gas_sold)}</p>
                  <p className="fw-bold text-secondary">Gas quantity sold</p>
                </div>
                <div className="col-6">
                  <p className="fw-bold fs-4">
                    {data && data.currency} {data && nFormatter(data.retailer_sales_made, 2)}
                  </p>
                  <p className="fw-bold text-secondary">Sales made</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6">
            <div className={`${classes.daily_records_boxes} p-3 bg-light`}>
              <h4>End Users</h4>
              <hr />
              <div className="row">
                <div className="col-6">
                  <p className="fw-bold fs-4">{data && convertTons(data.enduser_gas_sold)}</p>
                  <p className="fw-bold text-secondary">Gas quantity sold</p>
                </div>
                <div className="col-6">
                  <p className="fw-bold fs-4">
                    {data && data.currency} {data && nFormatter(data.enduser_sales_made, 2)}
                  </p>
                  <p className="fw-bold text-secondary">Sales made</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between mb-3">
          <h4>Daily Sales Record</h4>
          <Link
            to={`${match.url}/allrecords`}
            type="button"
            className={`btn ${classes.daily_records_view_all_button}`}>
            View More
          </Link>
        </div>

        <div className={classes.daily_records_table_wrapper}>
          <table className={`table table-striped ${classes.daily_records_table}`}>
            <thead>
              <tr>
                <th scope="col">Transaction ID</th>
                <th scope="col">Customer Type</th>
                <th scope="col">Customer Name</th>
                <th scope="col">Phone No.</th>
                <th scope="col">Gas Quantity Purchased</th>
                <th scope="col">Price/Kg</th>
                <th scope="col">Amount</th>
                <th scope="col">Status</th>
                <th scope="col">Price Approval</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr className="py-3">
                  <td colSpan={9}>
                    <div className="d-flex justify-content-center w-100">
                      <Spinner className="spinner" animation="border" variant="dark" />
                    </div>
                  </td>
                </tr>
              )}
              {data &&
                data.daily_sales_history.length > 0 &&
                data.daily_sales_history.map((tx) => (
                  <tr key={tx.transaction_id}>
                    <td>{tx.transaction_id}</td>
                    <td>
                      {tx.firstname} {tx.lastname}
                    </td>
                    <td>{tx.customer_type}</td>
                    <td>{tx.phone}</td>
                    <td>{tx.gas_quantity}</td>
                    <td>{tx.gas_price}</td>
                    <td>{tx.amount}</td>
                    <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>
                      {tx.status}
                    </td>
                    <td>Standard</td>
                  </tr>
                ))}

              {!loading && data && data.daily_sales_history.length === 0 && (
                <tr>
                  <td colSpan={9} className="w-100 text-center">
                    No Recent History
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DSRHome;
